var map = {
	"./hkie-white.png": "194f",
	"./hkie.png": "d8cb",
	"./hkig-white.png": "500d",
	"./hkig.png": "ea4d",
	"./hkigOld.png": "21bb",
	"./hkis-white.png": "a2d0",
	"./hkoig-white.png": "ca37"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a0b7";